import { Injectable, ApplicationRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class FeatureService {

  usingFeature: boolean = false;
  currentFeatureInstruction: string = '';
  featureToExecute: string;
  requestObject: any;

  saveMapFeatureChangeSource = new BehaviorSubject<any>(null);
  saveMapFeatureChangeStream = this.saveMapFeatureChangeSource.asObservable();

  shareMapFeatureChangeSource = new BehaviorSubject<any>(null);
  shareMapFeatureChangeStream = this.shareMapFeatureChangeSource.asObservable();

  constructor(public appRef: ApplicationRef) { }

  updateFeature(feature?) {
    this.resetFeatures();
    if(feature) {
      this.usingFeature = true;
      this.generateInstruction(feature);
    }
    this.appRef.tick();
  }

  resetFeatures() {
    this.usingFeature = false;
    this.currentFeatureInstruction = '';
  }

  generateInstruction(feature) {
    switch(feature) {
      case 'add-ring' :
        this.currentFeatureInstruction = 'To draw another ring';
        break;
      case 'add-drivetime' :
        this.currentFeatureInstruction = 'To draw another drivetime';
        break;
      case 'add-polygon' :
        this.currentFeatureInstruction = 'To draw a polygon';
        break;
      case 'save-map' :
        this.currentFeatureInstruction = 'To save your map';
        break;
      case 'share-map' :
        this.currentFeatureInstruction = 'To share your map';
        break;
      case 'save-property' :
        this.currentFeatureInstruction = 'To save your property';
        break;
      case 'edit-property' :
        this.currentFeatureInstruction = 'To edit your property';
        break;
      case 'save-retailer' :
        this.currentFeatureInstruction = 'To save your retailer';
        break;
      case 'edit-retailer' :
        this.currentFeatureInstruction = 'To edit your retailer';
        break;
      case 'move-retailer' :
        this.currentFeatureInstruction = 'To move your retailer';
        break;
      case 'remove-retailer' :
        this.currentFeatureInstruction = 'To remove your retailer';
        break;
      case 'save-marker' :
        this.currentFeatureInstruction = 'To save your marker';
        break;
    }
    this.currentFeatureInstruction += `, you'll need to sign up real quick`;
  }

  updateExecutionFeature(featureToExecute, requestObject) {
    this.featureToExecute = featureToExecute;
    this.requestObject = requestObject;
  }

  resetExecutionFeature() {
    this.featureToExecute = null;
    this.requestObject = null;
  }

  executeFeature() {
    let w = (<any>window);
    switch(this.featureToExecute) {
      case 'add-ring':
        for(let distance of this.requestObject.distances) {
          this.requestObject.data.distance = distance;
          w.rings.add(this.requestObject.data)
        }
        break;

      case 'add-ring-drawing-mode':
        w.addClass(w.domBody, 'add-stuff');
        w.demographicPoint.startDrawingMode({rings: true});
        break;

      case 'add-drivetime' :
        for(let distance of this.requestObject.distances) {
          this.requestObject.data.distance = distance;
          w.driveTime.add(this.requestObject.data)
        }
        break;

      case 'add-drivetime-drawing-mode':
        w.addClass(w.domBody, 'add-stuff');
        w.demographicPoint.startDrawingMode({driveTime: true});
        break;

      case 'add-polygon' :
        w.addClass(w.domBody, 'add-stuff');
        w.polygon.drawPolygon();
        break;

      case 'save-map' :
        this.saveMapFeatureChangeSource.next(this.requestObject);
        break;
      case 'share-map' :
        this.shareMapFeatureChangeSource.next(this.requestObject);
        break;
      case 'save-property' :
        w.Events.publish('addPropertyAfterSignup', this.requestObject);
        break;
      case 'edit-property' :
        w.Events.publish('editPropertyAfterSignup', this.requestObject);
        break;
      case 'move-retailer' :
        w.Events.publish('moveRetailer', this.requestObject);
        break;
      case 'remove-retailer' :
        w.Events.publish('removeRetailer', this.requestObject);
        break;
      case 'save-marker' :
        w.Events.publish('addPinAfterSignup', this.requestObject);
        break;
      case 'add-property-ring'  :
        w.rings.add(this.requestObject);
        break;
      case 'add-property-drivetime' :
        w.driveTime.add(this.requestObject);
        break;
      case 'add-traffic-segment-marker' :
        w.apiTrafficInrixStreetSegment.trafficSegmentDetailMarkers.push(this.requestObject);
        w.saveMap.getPinnedTrafficSegments();
        w.saveMap.setPinnedTrafficSegments();
        w.apiTrafficInrixStreetSegment.trafficSegmentDetailMarkers = [];
        break;
    }
    this.resetExecutionFeature();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/feature.service.ts